<div class="modal-header">
    <h5 class="modal-title">Shipment</h5>

    <button (click)="close()" type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <p *ngIf="loading" class="text-muted">Indlæser ...</p>

    <div *ngIf="!loading && _shipment && shipmentRoutes">
        <app-shipment-edit-form [_shipment]="shipment" [shipmentRoutes]="shipmentRoutes" [parentModal]="modal"></app-shipment-edit-form>
    </div>
</div>

<div class="modal-footer">
    <button (click)="close()" type="button" class="btn  btn-secondary" data-dismiss="modal"><span i18n>Close</span>
    </button>
</div>
